export enum PAYMENT_TYPE {
  billable = 'billable',
  nonBillable = 'non billable',
}
